<div
  #trigger="cdkOverlayOrigin"
  cdkOverlayOrigin
  class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-xl text-neutral-0"
  [ngClass]="
    computedCurrentAssignee()?.id
      ? { 'bg-info-500': !isOpen(), 'bg-info-600': isOpen(), 'hover:bg-info-600': true }
      : { 'bg-neutral-300': !isOpen(), 'bg-neutral-400': isOpen(), 'hover:bg-neutral-400': true }
  "
  [matTooltip]="computedCurrentAssignee()?.name || ('task.message.selectAssignee' | translate)"
  (click)="toggleOverlay()"
>
  @if (computedCurrentAssignee()?.name) {
    {{ currentAssigneeInitials() }}
  } @else {
    <mat-icon [fontIcon]="'assignment_ind'"></mat-icon>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayDisposeOnNavigation]="true"
  (backdropClick)="closeOverlay()"
>
  <mat-card class="w-96">
    <mat-card-content>
      <mat-form-field class="w-full">
        <mat-label>{{ "systemUser.message.searchPlaceholder" | translate }}</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          [formControl]="searchControl"
        />
      </mat-form-field>

      <div class="max-h-60 overflow-y-auto">
        @if (isLoading()) {
          <div class="flex justify-center py-4">
            <span class="text-sm text-neutral-500">{{ "systemUser.message.loading" | translate }}</span>
          </div>
        } @else {
          @for (assignee of filteredAssignees(); track assignee.id) {
            <div
              class="flex cursor-pointer items-center gap-3 rounded-lg px-3 py-2"
              [ngClass]="assignee.id === computedCurrentAssignee()?.id ? 'bg-primary-300 hover:bg-primary-400' : 'hover:bg-neutral-100'"
              (click)="selectAssignee(assignee)"
            >
              <div class="flex h-8 w-8 items-center justify-center rounded-full bg-info-500 text-sm text-neutral-0">
                {{ getInitials(assignee?.name || "") }}
              </div>
              <span class="text-sm text-neutral-500">{{ assignee?.name }}</span>
            </div>
          } @empty {
            <div class="py-4 text-center text-sm text-neutral-500">{{ "systemUser.message.emptyList" | translate }}</div>
          }
        }
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
